export default {
  matching: {
    training: {
      legend: "Activa el módulo y la visualización en el catálogo",
      domains: {
        delete: {
          title: "Eliminar este ámbito de formación",
        },
      },
    },
    group: {
      title: "Grupo",
      legend: "Abre o cierra las candidaturas",
    },
    groups: {
      title: ({ plural }) => plural(["Grupo", "Grupos"]),
      edit: {
        title: "Modificar la ficha del grupo",
      },
      view: {
        title: "Consultar la ficha del grupo",
      },
      sheet: {
        title: "Ficha del grupo",
        title_with_name: "Ficha del grupo — {name}",
        candidacy_opening_section: "Apertura de candidaturas",
        objectives_section: "Objetivos y capacidad de acogida",
        save_success: "Ficha del grupo guardada",
      },
      candidacy_status_upcoming: "Próximamente",
      candidacy_status_open: "Abiertas",
      candidacy_status_finalized: "Finalizadas",
      candidacy_status_full: "Completo",
      candidacy_status_full_waitlist: "Completo — lista de espera",
      candidacy_status_closed: "Cerradas",
    },
    prospects: {
      title: ({ plural }) => plural(["Prospecto", "Prospectos"]),
      view: {
        title: "Ver la ficha",
      },
      send_email: {
        title: "Enviar un email",
      },
      filters: {
        title: "Filtros rápidos",
        active: "Activos",
        passive: "Pasivos",
        unsubscribed: "Dados de baja",
        candidates: "Candidatos",
        stages_title: "Filtrar candidatos por etapa",
        advanced: {
          title: "Buscar",
          search_label: "Buscar por nombre o email",
          results_announcement: ({ plural, named }) =>
            plural(["Sin resultados", `${named("count")} resultado`, `${named("count")} resultados`]),
        },
      },
    },
    unsubscribeStats: {
      title: "Bajas",
      total: ({ plural, named }) => plural([`${named("count")} baja`, `${named("count")} bajas`]),
      by_reason: "Distribución por motivo",
      evolution: "Evolución en el tiempo",
      reason: "Motivo",
      count: "Número",
      from: "Periodo de inicio (mes)",
      to: "Periodo de fin (mes)",
    },
    settings: {
      success: "Registro efectuado. Los cambios ya están activos.",
    },
    config: {
      candidateWorkflow: {
        edit_title: "Modificar la pestaña «{name}»",
        edit_success: "Pestaña guardada",
        blocks: {
          edit_title: "Modificar el bloque «{name}»",
          edit_success: "Bloque guardado",
        },
        fields: {
          edit_title: "Modificar el campo «{name}»",
          edit_success: "Campo guardado",
          conditional: "Solo se muestra si «{target}» está completado",
        },
        steps: {
          intro: "Etapas",
          edit_title: "Modificar la etapa «{name}»",
          edit_success: "Etapa guardada",
        },
      },
    },
    catalog: {
      title: ({ plural }) => plural(["Catálogo", "Catálogos"]),
      edit: {
        title: "Modificar la ficha de catálogo",
      },
      view: {
        title: "Consultar la ficha de catálogo",
      },
      sheet: {
        title: "Ficha de catálogo",
        title_with_name: "Ficha de catálogo — {name}",
        subtitle: "Elementos visibles en el catálogo y la landing page",
        mode_edit: "Modo de modificación",
        mode_view: "Solo lectura — derecho no concedido",
        presentation_image: "Imagen de presentación",
        presentation_text: "Texto de presentación",
        commercial_brochure: "Folleto comercial",
        website_url: "URL del sitio web",
        no_file: "Ningún archivo",
        qr_code_alt: "Código QR de la ficha de catálogo",
        qr_url_label: "Enlace codificado por el código QR",
        save_success: "Ficha de catálogo guardada",
        download_unavailable: "Ningún folleto disponible para descargar.",
        actions: {
          replace: "Reemplazar",
          remove: "Eliminar",
          download: "Descargar",
          copy: "Copiar la imagen",
          copy_success: "¡Código QR copiado al portapapeles!",
          copy_error: "No se ha podido copiar el código QR.",
          copy_unsupported: "Su navegador no admite la copia de imágenes.",
          copy_url: "Copiar el enlace",
          copy_url_success: "¡Enlace copiado al portapapeles!",
          copy_url_error: "No se ha podido copiar el enlace.",
          uploading: "Enviando el archivo…",
          upload_error: "Se ha producido un error al enviar el archivo.",
        },
      },
    },
    landing_page: {
      add: {
        title: "Añadir un origen",
        success: "¡Origen añadido con éxito!",
      },
      edit: {
        title: "Modificar este origen",
        success: "¡Origen modificado con éxito!",
      },
      delete: {
        title: "Eliminar este origen",
        confirmation: "¿Está seguro de que desea eliminar este origen de landing page?",
        success: "¡Origen de landing page eliminado con éxito!",
      },
      qr_code: {
        see: "Ver el código QR",
        title: "Código QR de la landing page",
        alt: "Código QR de la landing page",
        download: "Descargar",
        copy: "Copiar la imagen",
        copy_success: "¡Código QR copiado al portapapeles!",
        copy_error: "No se ha podido copiar el código QR.",
        copy_unsupported: "Su navegador no admite la copia de imágenes.",
      },
      url: {
        copy: {
          title: "Copiar el enlace",
          success: "¡Enlace copiado correctamente!",
        },
      },
      filters: {
        level: {
          label: "Nivel de estudios buscado",
          unknown: "No lo sé",
          load_error: "No se pudieron cargar los niveles, intenta de nuevo.",
          retry: "Reintentar",
        },
        domain: {
          label: "Ámbito de formación",
          hint_multiple: "(varias opciones posibles)",
          search_placeholder: "Buscar un ámbito (ej. informática, comercio…)",
          empty_search: "Ningún ámbito coincide con “{search}”.",
          select_level_first: "Elige un nivel de estudios para ver los ámbitos disponibles.",
          show_all: "Mostrar los {count} ámbitos",
          collapse: "Reducir los ámbitos",
          load_error: "No se pudieron cargar los ámbitos, intenta de nuevo.",
          retry: "Reintentar",
          remove: "Quitar {name}",
          formation_count: ({ plural, named }) =>
            plural([`${named("count")} formación`, `${named("count")} formaciones`]),
        },
        training: {
          label: "Formaciones disponibles",
          search_placeholder: "Buscar una formación por palabras clave…",
          selected_count: ({ plural, named }) =>
            plural([
              `${named("count")}/${named("max")} formación seleccionada`,
              `${named("count")}/${named("max")} formaciones seleccionadas`,
            ]),
          // Sin tope (attr["data-max-count"] ausente) : sin "/{max}" que mostrar.
          selected_count_no_max: ({ plural, named }) =>
            plural([`${named("count")} formación seleccionada`, `${named("count")} formaciones seleccionadas`]),
          total_count: ({ plural, named }) => plural([`${named("total")} resultado`, `${named("total")} resultados`]),
          load_more: ({ plural, named }) =>
            plural([
              `Ver ${named("count")} formación más (${named("remaining")} restantes)`,
              `Ver ${named("count")} formaciones más (${named("remaining")} restantes)`,
            ]),
          adapted_to_level: "Adaptado a tu nivel",
          empty: "Ninguna formación coincide con estos criterios por el momento.",
          more_info: "Más información",
          close: "Cerrar",
          select: "Seleccionar esta formación",
          selected: "Formación seleccionada",
          max_selection_reached: "Solo se pueden seleccionar hasta {max} formaciones.",
          load_error: "No se pudieron cargar las formaciones, intenta de nuevo.",
          retry: "Reintentar",
        },
      },
    },
    candidateStudies: {
      title: "Mis estudios",
      intro: "Indica tus diplomas y certificaciones para completar tu candidatura.",
      add: "Añadir",
      add_degree_title: "Añadir un diploma",
      edit_degree_title: "Modificar este diploma",
      add_certification_title: "Añadir una certificación",
      edit_certification_title: "Modificar esta certificación",
      save_success: "Entrada guardada",
      empty: "Todavía no hay ninguna entrada",
      minimum_not_reached: "Añade al menos una entrada para completar este bloque",
      max_reached_tooltip: "Número máximo de entradas alcanzado",
      delete_confirm_title: "¿Eliminar esta entrada?",
      delete_success: "Entrada eliminada",
      move_up: "Subir",
      move_down: "Bajar",
      moved: "{name}: entrada número {position} de {total}.",
      reorder_error: "No se ha podido guardar el orden de tus entradas, se mantiene el orden anterior.",
      entry: {
        edit: "Modificar",
        delete: "Eliminar",
        degree_type: "Tipo de diploma",
        institution: "Centro",
        department: "Departamento",
        country: "País",
        year: "Año",
        organization: "Organismo",
      },
    },
    candidateInformation: {
      read_only_notice: "Esta pestaña ya no se puede modificar en esta etapa de su expediente.",
      steps_title: "Mi expediente",
      title: "Mis datos personales",
      tab_empty: "Esta pestaña estará disponible próximamente.",
      load_error: "No se pudo cargar su expediente, intente de nuevo.",
      retry: "Reintentar",
    },
    applications: {
      hint_reorder:
        "Ordena tus opciones por orden de preferencia: arrastra una tarjeta por su asa o usa los botones Subir y Bajar.",
      empty: "Todavía no tienes ninguna opción de candidatura.",
      rank: ({ named }) => `${named("rank")}.ª opción`,
      move_up: "Subir la opción {name}",
      move_down: "Bajar la opción {name}",
      moved: "{name}: opción número {position} de {total}.",
      reorder_error: "No se ha podido guardar el orden de tus opciones, se mantiene el orden anterior.",
      closed_title: "Opciones cerradas",
      view: "Ver",
      edit: "Modificar",
      tab_count: "{count} opción activa | {count} opciones activas",
      modal: {
        title: "Mi opción",
        training: "Formación",
        group: "Grupo",
        status: "Estado",
        year: "Año",
        letter_label: "Carta de motivación",
        letter_hint: "{max} caracteres como máximo.",
        letter_counter: "{count} / {max} caracteres",
        letter_locked: "Tu carta de motivación ya no se puede modificar en esta etapa.",
        save: "Guardar",
        close: "Cerrar",
        saved: "Carta de motivación guardada",
        withdraw: "Retirar esta opción",
        withdraw_confirm: "¿Seguro que quieres retirar esta opción?",
        withdraw_confirm_yes: "Sí, retirar esta opción",
        withdraw_cancel: "Cancelar",
        withdrawn: "Opción retirada",
      },
    },
  },
};
